var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutgoingOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2H14M14 2V5.33333M14 2L10 6M3.33333 2C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V4C2 9.52267 6.47733 14 12 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V10.48C13.9999 10.3401 13.9558 10.2039 13.874 10.0904C13.7921 9.97701 13.6767 9.8922 13.544 9.848L10.5487 8.84933C10.3964 8.79873 10.2311 8.80472 10.0829 8.86619C9.93473 8.92766 9.8137 9.0405 9.742 9.184L8.98867 10.6887C7.35619 9.95096 6.04875 8.64328 5.31133 7.01067L6.816 6.25867C6.9595 6.18697 7.07234 6.06593 7.13381 5.91776C7.19528 5.76959 7.20127 5.60423 7.15067 5.452L6.152 2.45533C6.10765 2.32265 6.02269 2.20729 5.90915 2.12557C5.7956 2.04385 5.65923 1.99992 5.51933 2H3.33333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutgoingOutline);
export default __webpack_public_path__ + "static/media/PhoneOutgoingOutline.45007d55e5ffa932fcdb2de20d06eb7c.svg";
export { ForwardRef as ReactComponent };